import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { PersonContactService } from '../_services';
import * as PersonContactActions from '../_actions/personContact';

@Injectable({
  providedIn: 'root',
})
export class PersonContactEffects {
  loadPersonContacts$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonContactActions.loadPersonContacts),
      mergeMap(() =>
        this.personContactService.getPersonContacts().pipe(
          map((personContacts) =>
            PersonContactActions.loadPersonContactsSuccess({ personContacts })
          ),
          catchError((error) => of(PersonContactActions.loadPersonContactsFailure({ error })))
        )
      )
    )
  );

  addPersonContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonContactActions.addPersonContact),
      mergeMap(({ personContact }) =>
        this.personContactService.savePersonContact(personContact).pipe(
          map((savedPersonContact) =>
            PersonContactActions.addPersonContactSuccess({ personContact: savedPersonContact })
          ),
          catchError((error) => of(PersonContactActions.addPersonContactFailure({ error })))
        )
      )
    )
  );

  updatePersonContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonContactActions.updatePersonContact),
      mergeMap(({ personContact }) =>
        this.personContactService.savePersonContact(personContact).pipe(
          map((updatedPersonContact) =>
            PersonContactActions.updatePersonContactSuccess({ personContact: updatedPersonContact })
          ),
          catchError((error) => of(PersonContactActions.updatePersonContactFailure({ error })))
        )
      )
    )
  );

  deletePersonContact$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PersonContactActions.deletePersonContact),
      mergeMap(({ id }) =>
        this.personContactService.deletePersonContact(id).pipe(
          map(() => PersonContactActions.deletePersonContactSuccess({ id })),
          catchError((error) => of(PersonContactActions.deletePersonContactFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private personContactService: PersonContactService
  ) {}
}
